import { _logout } from '@/services/api/auth'

export default {
	methods: {
		logoutUser (redirect) {
			_logout()
				.then(() => {
					this.$store.dispatch('logout', redirect)
				})
		}
	}
}
